


import React, {useState} from 'react';
import NavBar from '../NavBar/NavBar';
// import img1 from "../../Images/Landing.jpg"
import img1 from "../../Images/Websitecover.jpg"
import "./HeroSectionOrg.css"
import { Link } from 'react-router-dom';



function HeroSection() { 
 

  return <>
    <div className='HeroSectionWholeOrg'>
        
            <NavBar/>
            <div className='HeroContent'>

               <div className='wording'>

                  <h1>
                      For Organisations
                  </h1>
                  <p>Upskill your workforce. Transform your organization.</p>
                  <p>
                      
                      Learn online from the leaders in business education
                      Expand your business skills and engage with a global network of learners through our flexible, online courses. Wherever you are in your career—or the UNILUS Business School Online can help you achieve your goals.
                 
                  </p>

                  {/* dga */}

                  <button>
                    <Link className='linkItem' to={"/moreinfo"}> 
                         Request Info
                    </Link>
                    
                  </button>

               </div>
               <div className='video'>

                   <img src={img1}/>

               </div>

            </div>

        
                
    </div>

    {/* <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div>
    <div>
        <h1>dfagagr</h1>
    </div> */}
  
  </>
  
  ;
}

export default HeroSection;